import React from 'react';

const Usuarios = () => {
  return <h1>Bienvenido Usuarios</h1>;
};

export default Usuarios;
